import { useEffect, useState } from 'react';

interface VisualViewportBox {
  height: number;
  offsetTop: number;
}

const readVisualViewport = (): VisualViewportBox | null => {
  const { visualViewport } = window;

  if (!visualViewport) {
    return null;
  }

  return {
    height: visualViewport.height,
    offsetTop: visualViewport.offsetTop,
  };
};

export const useVisualViewport = () => {
  const [box, setBox] = useState(readVisualViewport);

  useEffect(() => {
    const { visualViewport } = window;

    if (!visualViewport) {
      return;
    }

    const handleChange = () => setBox(readVisualViewport());

    visualViewport.addEventListener('resize', handleChange);
    visualViewport.addEventListener('scroll', handleChange);

    return () => {
      visualViewport.removeEventListener('resize', handleChange);
      visualViewport.removeEventListener('scroll', handleChange);
    };
  }, []);

  return box;
};
